let en = {
  Title: 'Cloud',
  Subtitle: 'Blockchain full service platform.',
  Content: [
    {name: '<a target="_blank" href="https://open.sealsc.com">Open SC <img src="/static/link.svg"></a>', desc: 'Based on the accumulation of rich smart contracts, we provide an opened smart contract cloud. Users can deploy smart contract sets to implement their business needs on multiple public chains with a simple configuration operation.'},
    {name: 'CaaS', desc: 'Crosschain service based on seal protocol family. With this service, your business boundaries on blockchain will be unlimited.'},
    {name: 'BaaS', desc: 'Customizable standard seal-blockchain service, users can quickly build, deploy and run their own blockchain.'},
  ],
}

let zh = {
  Title: 'Cloud',
  Subtitle: '区块链全流程服务平台。',
  Content: [
    {name: '<a target="_blank" href="https://open.sealsc.com">Open SC <img src="/static/link.svg"></a>', desc: '基于丰富的智能合约积累，为用户提供开放性的合约云平台。用户仅需简单的配置操作，即可将符合业务需求的智能合约、智能合约集合部署到多条公链上。'},
    {name: 'CaaS', desc: '基于Seal跨链协议，拓展用户在区块链上的业务边界，为用户创造更大发展空间。'},
    {name: 'BaaS', desc: '构建于Seal-blockchain标准协议之上，让用户在能够快速构建、部署和运行自己的区块链服务。'},
  ],
}

let name = 'Service'

export default {
  name,
  en,
  zh
}